import cn from 'classnames';

import loader from 'assets/images/loading.gif';
import { ReturnComponentType } from 'common';

import './ProgressBar.scss';

type ProgressBarType = {
  progress: number;
  className?: string;
  isOldFile?: boolean;
};
export const ProgressBar = ({
  progress,
  className,
  isOldFile = false,
}: ProgressBarType): ReturnComponentType => {
  return (
    <div className={cn('ProgressBar', className)}>
      <div
        className="ProgressBar_Container"
        style={{
          width: `${progress}%`,
        }}
      />
      {progress === 100 && !isOldFile && (
        <img src={loader} alt="Loading..." className="ProgressBar_Loader" />
      )}
    </div>
  );
};
